import { MAX_CATEGORY_PATH_SEGMENTS } from "@/constants/category";

const MAX_REGIONS = 100;

export interface SearchNavigationPayload {
  query?: string;
  queryDe?: string;
  regions?: string[];
  categorySlugs?: string[];
}

const normalizeCategorySlug = (value: string) => {
  const slug = value.trim().toLowerCase();
  return /^[a-z0-9-]+$/.test(slug) ? slug : null;
};

export const buildSearchQueryString = (payload: SearchNavigationPayload) => {
  const params = new URLSearchParams();
  const query = (payload.query ?? "").trim();
  if (query) {
    params.set("query", query);
  }
  const queryDe = (payload.queryDe ?? "").trim();
  if (queryDe) {
    params.set("queryDe", queryDe);
  }

  const regions = Array.from(
    new Set(
      (payload.regions ?? [])
        .map((value) => value?.trim())
        .filter((value): value is string => !!value)
    )
  ).slice(0, MAX_REGIONS);
  regions.forEach((region) => params.append("regions", region));

  const categoryPath = (payload.categorySlugs ?? [])
    .map((slug) => normalizeCategorySlug(slug))
    .filter((slug): slug is string => !!slug)
    .slice(0, MAX_CATEGORY_PATH_SEGMENTS);
  if (categoryPath.length > 0) {
    params.set("categories", categoryPath.join("/"));
  }

  return params.toString();
};

export const readQueryFromSearchString = (search: string | undefined) => {
  if (!search) return "";
  const value = search.startsWith("?") ? search.substring(1) : search;
  return (new URLSearchParams(value).get("query") ?? "").trim();
};
